import { Environment } from '../core.tokens';

export const getWebSocketUrl = (env: Environment) => {
  const u = new URL(env.serverUrl);
  return `${env.production ? 'wss' : 'ws'}://${u.hostname}:${env.webSocketPort}${env.webSocketPath}`;
};
